import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-crud-router',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './crud-router.component.html',
  styleUrl: './crud-router.component.scss',
})
export class CrudRouterComponent {}
